export default "__VITE_ASSET__N2vIYvjf__"